import { serverTimestamp } from 'firebase/firestore';
import { map } from 'lodash';
import AppUtils from 'src/utils/AppUtils';

import GenericDB from './generic-db';

export default class DataDB extends GenericDB {
  constructor() {
    super('data');
  }

  /**
   * @param {Object & { id: string, client: string }} session
   */
  async softDeleteBySession(session) {
    const sessionData = await this.readAll([
      ['client', '==', session.client],
      ['session', '==', session.id],
    ]);

    await AppUtils.allSettled(
      map(sessionData, async (data) => this.update({
        id: data.id,
        isDeleted: true,
        deleteTimestamp: serverTimestamp(),
      })),
    );
  } // softDeleteBySession()
}
